import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { pluck, take, filter, switchMap } from 'rxjs/operators';
import { IMenuFilter } from '../tokens/menu-filter.token';
import { customerConfig, loyaltyAccountSelector, getSharedLoyaltyState } from '../../store-provider/redux/selectors';
import { combineLatest, of, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoyaltyMenuFilterService implements IMenuFilter {
  constructor(private store: Store<any>) {}

  // returns disallowed menu items
  private getForbiddenCodes(enrolled: boolean, dm: boolean, accountEnabled: boolean): string[] {
    const codes = [];
    if (!enrolled) {
      codes.push('amadeus-plus-me/bonuspoints', 'amadeus-plus-me/details', 'amadeus-plus-me-gift-catalog',
                  'loyalty/bonuspoints','amadeus-plus-me/statuspoints');
    }
    if (enrolled || (!accountEnabled && dm)) {
      codes.push('amadeus-plus-me/enrollment');
    }
    return codes;
  }

  // @loyaltyDocs: remove menu items depending on user configuration
  execute(menuList: any): Observable<any> {
    return combineLatest([
      this.store.pipe(select(customerConfig), pluck('customerConfig')),
      this.store.pipe(
        select(getSharedLoyaltyState),
        filter(state => !state.isLoading),
        pluck('loyaltyConfig')
      ),
      this.store.pipe(
        select(loyaltyAccountSelector),
        filter(state => !state.isLoading)
      )]
    ).pipe(
      take(1),
      switchMap(([customerConfig, loyaltyConfig, accountState]) => {
        const mainMenu = menuList.navigation;
        const loyaltyMenuItem = mainMenu.find(({ code }) => 'amadeus-plus-me' === code);
        if (!loyaltyMenuItem) {
          return of(menuList);
        }
        const forbiddenCodes = this.getForbiddenCodes(
          !!accountState['agentNumber'],
          customerConfig['is_decision_maker'],
          customerConfig['loyalty_enabled_for_account']
        );
        loyaltyMenuItem['children'] = loyaltyMenuItem['children'].filter(
          ({ code }) => forbiddenCodes.indexOf(code) === -1
        );
        if (!loyaltyConfig['enabled_for_market'] || !loyaltyMenuItem['children'].length) {
          mainMenu.splice(mainMenu.indexOf(loyaltyMenuItem), 1);
        }
        return of(menuList);
      })
    );
  }
}
